module.exports = __webpack_public_path__ + "static/retail-stores-3fa3d63d3ac1df749bb5c449df43e74c.svg";